export const itTranslation = {
  nav: {
    categories: "Tutte le Categorie",
  },
  hero: {
    badge: "Piattaforma Italiana #1 per Spreadsheet Shopping",
    title1: "Itaobuy",
    title2: "Spreadsheet",
    title3: "Knowledge Base",
    description: "La risorsa più completa in Italia per la ricerca prodotti tramite fogli di calcolo organizzati. Confronta, analizza e scegli i migliori prodotti con dati strutturati e guide esperte.",
    ctaPrimary: "Esplora il Database",
    ctaSecondary: "Leggi la Guida SEO",
  },
  about: {
    title: "Cos'è Itaobuy Spreadsheet?",
    paragraph1: "Itaobuy Spreadsheet è uno strumento innovativo che raccoglie e organizza informazioni dettagliate sui prodotti in un formato strutturato e facile da consultare. Pensato per chi cerca qualità, convenienza e dati affidabili prima di effettuare un acquisto.",
    paragraph2: "La nostra piattaforma offre guide complete, confronti approfonditi e risorse aggiornate per aiutarti a prendere decisioni informate. Dalle sneakers agli accessori moda, ogni categoria è coperta con precisione e attenzione ai dettagli.",
    paragraph3: "Con oltre 500 articoli SEO ottimizzati e 14 categorie prodotto, Itaobuy Spreadsheet rappresenta il punto di riferimento per gli acquirenti italiani che desiderano informazioni chiare e organizzate prima di ogni acquisto.",
    cta: "Scopri le Risorse",
    stat1: "500+",
    stat1Label: "Articoli SEO",
    stat2: "14",
    stat2Label: "Categorie Prodotto",
  },
  categories: {
    title1: "Esplora le",
    title2: "Categorie Prodotto",
    subtitle: "Naviga tra le nostre categorie per trovare prodotti selezionati e guide dettagliate per ogni tipologia.",
  },
  articles: {
    title1: "Itaobuy Sheet",
    title2: "Guide & Articoli",
    readMore: "Leggi l'Articolo",
  },
  reviews: {
    badge: "Community Reviews",
    title1: "Cosa Dicono",
    title2: "Gli Utenti Italiani",
    subtitle: "Feedback reali dalla nostra community di acquirenti che utilizzano Itaobuy Spreadsheet per le loro ricerche.",
  },
  cta: {
    title: "ACQUISTA ORA SU",
    titleBrand: "ITAOBUY",
    subtitle1: "Accedi alle risorse complete e ai fogli di calcolo",
    subtitle2: "aggiornati per lo shopping internazionale.",
    button: "BUY IT NOW",
  },
  footer: {
    col1Title: "Categorie Prodotto",
    col2Title: "Risorse SEO",
    col3Title: "Legale",
    col4Title: "Contatti",
    brand: "Itaobuy",
    brandSub: "Sheet",
    brandDesc: "La piattaforma italiana di riferimento per la ricerca prodotti con fogli di calcolo organizzati.",
    copyright: "© 2026 itaobuyspread.work. Tutti i diritti riservati.",
  },
  article: {
    backHome: "← Torna alla Home",
    breadcrumb: "Home / Guide & Articoli",
  },
};